import { Routes, RouterModule, PreloadAllModules  } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ErrorComponent } from './pages/error/error.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
    { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule) },
    { path: 'reroute', loadChildren: () => import('./pages/reroute/reroute.module').then(m => m.RerouteModule) },
    //{ path: 'backend', loadChildren: 'app/pages/cedere-backend/cedere-back-end.module#CedereBackEndModule' },
    { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
  { path: '**', component: ErrorComponent }
];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
   // useHash: true
});